import { DefaultQueryParams, PaginatedResponse } from '@frontend/api-utils';
import { ColliStateName } from './colli-state';

export interface Colli {
    iot_id: string | null;
    state: ColliStateName;
    label: string;
    index: number | null;
    type: ColliType;
    notes: string | null;
    spot_id: string | null;
    module_id: string | null;
    slot_id: string | null;
    current_spot_id: string | null;
    current_module_id: string | null;
    current_slot_id: string | null;
    workflow_id: string;
    update_timestamp: string;
    id: string;
    account_id: string;
    transaction_id: string;
    creation_timestamp: string;
}

export interface CreateColli {
    iot_id?: string | null;
    state?: ColliStateName | null;
    label?: string;
    index?: number | null;
    type?: ColliType | null;
    notes?: string | null;
    spot_id?: string | null;
    module_id?: string | null;
    slot_id?: string | null;
    current_spot_id?: string | null;
    current_module_id?: string | null;
    current_slot_id?: string | null;
    workflow_id?: string;
}

export interface UpdateColli {
    null_fields?: string[] | null;
    iot_id?: string | null;
    state?: ColliStateName | null;
    label?: string;
    index?: number | null;
    type?: ColliType | null;
    notes?: string | null;
    spot_id?: string | null;
    module_id?: string | null;
    slot_id?: string | null;
    current_spot_id?: string | null;
    current_module_id?: string | null;
    current_slot_id?: string | null;
    workflow_id?: string;
}

export enum ColliType {
    CHILLED = "chilled",
    FROZEN = "frozen",
    HEATED = "heated",
    LIVESTOCK = "livestock",
    STANDARD = "standard"
}

enum QueryParams {
    ACCOUNT_ID = 'account_id',
    TRANSACTION_ID = 'transaction_id',
    LABEL = 'label',
    STATE = 'state',
    SPOT_ID = 'spot_id',
    CURRENT_SPOT_ID = 'current_spot_id',
    SLOT_ID = 'slot_id',
    CURRENT_SLOT_ID = 'current_slot_id',
}
export type ColliQueryParams = DefaultQueryParams & QueryParams;
export type ColliListResponse = PaginatedResponse<Colli>;